import { color } from '@creditornot/cb-ingredients/design-tokens';
import { SupportLayerPage } from '@creditornot/support-layer';
import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';

export const StyledSupportLayerPage = styled(SupportLayerPage)`
  height: auto;
  min-height: auto;

  @media (width >= ${MOBILE_BREAKPOINT + 1}px) {
    margin-block-start: 24px;
    padding-block-end: 48px;
  }

  .support-layer {
    &__main {
      padding: 16px;
      border-radius: 8px;
      border: 1px solid ${color.border};
    }

    &__heading {
      padding-block-end: 8px;

      [class^='support-layer-Heading'] {
        font-size: 20px;
        font-weight: 600;
        line-height: 1.5;
      }

      [class^='support-layer-Heading_EyebrowText'] {
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
`;
